import { expSmooth } from './math.js';

/** A value that eases towards its target with frame-rate independent smoothing. */
export class Smoothed {
  private readonly halfLifeSeconds: number;
  private value = 0;

  constructor(halfLifeSeconds: number) {
    this.halfLifeSeconds = halfLifeSeconds;
  }

  public update(target: number, deltaSeconds: number): number {
    this.value = expSmooth(this.value, target, deltaSeconds, this.halfLifeSeconds);
    return this.value;
  }

  public get current(): number {
    return this.value;
  }
}
